import { useEffect, useRef, useState } from 'react';
import { useAppDispatch } from 'app/store';
import { setHeaderTitle } from 'features/ui/model/uiSlice';
import { useNavigate } from 'react-router-dom';
import { DrawerProduct } from 'widgets/product/ui/DrawerProduct';
import { useGetShopsQuery } from 'widgets/product/ui/api/getShopsApi';
import { useSyncState } from 'shared/hooks/useSyncState';
import { TableContentForMechanic } from 'entities/table/ui/TableContentForMechanic';
import { useDeleteProductMutation } from 'widgets/product/ui/api/shopCreateApi';

const fields = [
  {
    field: 'product_id',
    title: 'ID',
    width: '5%',
  },
  {
    field: 'title',
    title: 'Наименование',
    width: '10%',
  },
  {
    field: 'description',
    title: 'Описание',
    width: '20%',
  },
  {
    field: 'product_category_title',
    title: 'Категория',
    width: '20%',
  },
  {
    field: 'partner_title',
    title: 'Партнер',
    width: '20%',
  },
  {
    field: 'price',
    title: 'Стоимость единицы',
    width: '20%',
  },
];

export const ProductsWidget = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();
  const [pagination, setPagination] = useState<{
    page: number;
    count: number;
    search: string;
  }>({
    page: 1,
    count: 10,
    search: '',
  });

  const handlePromoSelect = (id: number) => {
    navigate(`/product/${id}`);
  };

  const { data: shopsList, isSuccess } = useGetShopsQuery({
    per_page: pagination.count,
    page: pagination.page,
    search: pagination.search,
  });

  const localShopList = { items: [] as any };
  if (shopsList) {
    shopsList?.forEach((item) =>
      localShopList.items.push({
        id: item.product_id,
        title: item.title,
        category: item.category,
        category_id: item.category_id,
        country: item.country,
        created_at: item.created_at,
        currency: item.currency,
        description: item.description,
        image: item.image,
        partner_id: item.partner_id,
        partner_title: item.partner_title,
        price: item.price,
        product_category_title: item.product_category_title,
        product_city_scope: item.product_city_scope,
        product_id: item.product_id,
        product_scope: item.product_scope,
        product_type: item.product_type,
        sku: item.sku,
        updated_at: item.updated_at,
      }),
    );
  }

  useEffect(() => {
    dispatch(setHeaderTitle('Товары'));
  }, [dispatch]);

  const searchRef = useRef('');
  const [isShowSearch, setIsShowSearch] = useState(false);
  const searchQuery = useSyncState('');

  const handleClearSearch = () => {
    setIsShowSearch(false);
    searchQuery.set('');
    searchRef.current = '';
    setPagination((prev) => ({
      ...prev,
      search: '',
    }));
  };
  const handleSetSearch = (search: string) => {
    searchQuery.set(search);
    searchRef.current = search;
  };

  const [deleteProductRequest] = useDeleteProductMutation();
  const handleDeleteProduct = (id: number) => {
    deleteProductRequest(id).then(() => {
      navigate('/product');
      setTimeout(() => {
        window.location.reload();
      }, 2500);
    });
  };

  return isSuccess ? (
    <div>
      <TableContentForMechanic
        title="Товары, доступные для продажи"
        isShowSearch={isShowSearch}
        onShowSearch={(showSearch) => setIsShowSearch(showSearch)}
        onClearSearch={handleClearSearch}
        search={searchQuery.get()}
        setSearch={handleSetSearch}
        fields={fields}
        list={{ list: localShopList.items }}
        count={localShopList.items.length}
        page={pagination.page}
        perPage={pagination.count}
        onPageChange={(_, page) => {
          setPagination((prev) => ({
            ...prev,
            page: page + 1,
          }));
        }}
        onRowsPerPageChange={(e) => {
          setPagination(() => ({
            page: 1,
            count: parseInt(e.target.value),
            search: pagination.search,
          }));
        }}
        onDeleteClick={handleDeleteProduct}
        onRowClick={handlePromoSelect}
        onChangeClick={() => {}}
      />
      <DrawerProduct />
    </div>
  ) : null;
};
